import { render, staticRenderFns } from "./questionLayer.vue?vue&type=template&id=21f2b524&scoped=true&"
import script from "./questionLayer.vue?vue&type=script&lang=js&"
export * from "./questionLayer.vue?vue&type=script&lang=js&"
import style0 from "./questionLayer.vue?vue&type=style&index=0&id=21f2b524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2b524",
  null
  
)

export default component.exports